import React, { useCallback, useEffect, useState } from "react";
import {
	Card,
	Banner,
	FormLayout,
	TextStyle,
	Button,
	ButtonGroup,
	Autocomplete,
	Icon,
	Modal,
	TextContainer,
	Select,
	TextField,
	Heading,
} from "@shopify/polaris";
import { Col, Row } from "reactstrap";
import {
	ArrowRightMinor,
	DeleteMinor,
	EditMajor,
	EditMinor,
	FlagMajor,
	TickSmallMinor,
	MaximizeMajor,
} from "@shopify/polaris-icons";
import callApi from "../../utils/apiCaller";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import PlanTable from "../Dashboard/PlanTable";

const CourierMapping = () => {
	const [mappingModalStatus, setmappingModalStatus] = useState(false);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [listMapping, setListMapping] = useState([]);

	const [modalPlan, setModalPlan] = useState(false);
	const dataSettings = useSelector((state) => state.dataSettings);

	const [yourCourierValue, setYourCourierValue] = useState("");
	const [mappingRule, setmappingRule] = useState("name");
	const [paypalCourierValue, setPaypalCourierValue] = useState("");
	const [yourCourierValueErr, setYourCourierValueErr] = useState("");
	const [paypalCourierValueErr, setPaypalCourierValueErr] = useState("");
	const [idMapping, setIdMapping] = useState(0);
	const [options, setOptions] = useState([]);

	const optionsRule = [
		{ label: "Courier Name", value: "name" },
		{ label: "Tracking number start with", value: "start" },
		{ label: "Tracking number end with", value: "end" },
	];

	useEffect(() => {
		getListPayPalCourier();
	}, []);
	const [deselectedOptions, setdeselectedOptions] = useState([]);
	const getListPayPalCourier = () => {
		let params = {
			action: "getListPayPalCourier",
		};
		callApi("get", params).then(async (res) => {
			if (res.data.listCourier) {
				setdeselectedOptions(res.data.listCourier);
				setListMapping(res.data.listMapping);
			}
		});
	};
	const saveMapping = () => {
		if (yourCourierValue == "") {
			setYourCourierValueErr("This field is required");
		} else if (paypalCourierValue == "") {
			setPaypalCourierValue("This field is required");
		} else {
			let params = {
				action: "saveMapping",
				id: idMapping,
				type: mappingRule,
				courier: yourCourierValue,
				paypalCourier: paypalCourierValue,
			};
			callApi("get", params).then(async (res) => {
				if (res.data.state === 1) {
					setmappingModalStatus(false);
					Swal.fire({
						icon: "success",
						title: "Successfully",
						text: res.data.msg,
						showCloseButton: false,
						showConfirmButton: false,
						timer: 3000,
					}).then(() => {
						window.location.reload();
					});
				}
			});
		}
	};

	const updateText = useCallback(
		(value) => {
			setYourCourierValueErr("");
			setYourCourierValue(value);

			if (value === "") {
				setOptions(deselectedOptions);
				return;
			}

			const filterRegex = new RegExp(value, "i");
			const resultOptions = deselectedOptions.filter((option) =>
				option.label.match(filterRegex)
			);
			setOptions(resultOptions);
		},
		[deselectedOptions]
	);

	const updateText2 = useCallback(
		(value) => {
			setPaypalCourierValueErr("");
			setPaypalCourierValue(value);

			if (value === "") {
				setOptions(deselectedOptions);
				return;
			}

			const filterRegex = new RegExp(value, "i");
			const resultOptions = deselectedOptions.filter((option) =>
				option.label.match(filterRegex)
			);
			setOptions(resultOptions);
		},
		[deselectedOptions]
	);

	const updateSelection = useCallback(
		(selected) => {
			const selectedValue = selected.map((selectedItem) => {
				const matchedOption = options.find((option) => {
					return option.value.match(selectedItem);
				});
				return matchedOption && matchedOption.label;
			});

			setSelectedOptions(selected);
			setYourCourierValue(selectedValue[0]);
		},
		[options]
	);
	const updateSelection2 = useCallback(
		(selected) => {
			const selectedValue = selected.map((selectedItem) => {
				const matchedOption = options.find((option) => {
					return option.value.match(selectedItem);
				});
				return matchedOption && matchedOption.label;
			});

			setSelectedOptions(selected);
			setPaypalCourierValue(selectedValue[0]);
		},
		[options]
	);

	const addMapping = () => {
		if (dataSettings.plan == "free") {
			Swal.fire({
				icon: "warning",
				title: "Need to upgrade Plan!",
				html: "This function is only available when using <b>Basic plan or higher</b>",
				showCancelButton: true,
				confirmButtonText: "Pick a higher Plan",
				showConfirmButton: true,
			}).then((result) => {
				if (result.value) {
					setModalPlan(true);
				}
			});
		} else {
			if (dataSettings.plan == "basic" || dataSettings.plan == "pro") {
				let maxMappings = dataSettings.plan == "basic" ? 2 : 10;
				if (listMapping.length >= maxMappings) {
					Swal.fire({
						icon: "warning",
						title: "Need to upgrade Plan!",
						html:
							"The <b>" +
							dataSettings.plan +
							"</b> plan can only set up to " +
							maxMappings +
							" mappings. Please upgrade to higher plan.",
						showCancelButton: true,
						confirmButtonText: "Pick a higher Plan",
						showConfirmButton: true,
					}).then((result) => {
						if (result.value) {
							setModalPlan(true);
						}
					});
				} else {
					setIdMapping(0);
					setPaypalCourierValue("");
					setYourCourierValue("");
					setmappingModalStatus(true);
					setmappingRule("name");
				}
			} else {
				setIdMapping(0);
				setPaypalCourierValue("");
				setYourCourierValue("");
				setmappingModalStatus(true);
				setmappingRule("name");
			}
		}
	};

	const editMapping = (mapping) => {
		setIdMapping(mapping.id);
		setPaypalCourierValue(mapping.paypal_courier);
		setYourCourierValue(mapping.courier);
		setmappingRule(mapping.type);
		setmappingModalStatus(true);
	};

	const changeYourCourier = (value) => {
		setYourCourierValue(value);
		setYourCourierValueErr("");
	};

	const deleteMapping = (mapping) => {
		Swal.fire({
			icon: "warning",
			title: "Are you sure?",
			text: "This mapping will be permanently deleted",
			showCancelButton: true,
			showConfirmButton: true,
		}).then((result) => {
			if (result.value) {
				deleteMappingId(mapping.id);
			}
		});
	};

	const deleteMappingId = (id) => {
		let params = {
			action: "deleteMappingId",
			id: id,
		};
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				setmappingModalStatus(false);
				Swal.fire({
					icon: "success",
					title: "Deleted",
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				}).then(() => {
					window.location.reload();
				});
			}
		});
	};

	const textField = (
		<Autocomplete.TextField
			onChange={updateText}
			value={yourCourierValue}
			label="Your Courier Name"
			error={yourCourierValueErr}
			helpText={
				mappingRule == "name"
					? "Example: Yunexpress"
					: mappingRule == "start"
					? "Example: 1ZA"
					: "Example: HK"
			}
		/>
	);
	const textField2 = (
		<Autocomplete.TextField
			onChange={updateText2}
			value={paypalCourierValue}
			label="PayPal Courier"
			error={paypalCourierValueErr}
			helpText="Example: UPS"
		/>
	);
	return (
		<Col
			style={{ marginTop: "20px" }}
			className="d-flex"
			xs="12"
			sm="12"
			md="12"
		>
			<Card title="Couriers Mapping" sectioned>
				<Row
					// style={{ textAlign: 'end' }}
					className="mb-2"
				>
					<Col>
						<a
							href="https://docs.synctrack.io/feature-guides/how-to-add-courier-mapping-rule"
							target="_blank"
						>
							View couriers mapping instruction
						</a>
					</Col>
				</Row>
				<div>
					<Banner title="Note" status="info" icon={FlagMajor}>
						<p
							className="text-left"
							style={{ lineHeight: "26px", fontSize: "15px" }}
						>
							Currently, the process of converting carrier names
							from Shopify to PayPal-supported carriers is fully
							automated. However, if you want to configure them
							yourself, you can use our function below
						</p>
					</Banner>
					<Row className="mt-4  ">
						<div className="w-100 text-right mr-5">
							<Button primary onClick={() => addMapping()}>
								Add Mapping
							</Button>
						</div>
					</Row>
					<Row>
						<div className="mt-4 w-100 ml-5">
							<FormLayout>
								<FormLayout.Group condensed>
									<TextStyle variation="strong">
										Mapping Type
									</TextStyle>
									<TextStyle variation="strong">
										Input
									</TextStyle>
									<TextStyle variation="strong"></TextStyle>
									<TextStyle variation="strong">
										PayPal Courier
									</TextStyle>
									<TextStyle variation="strong"></TextStyle>
								</FormLayout.Group>
								{listMapping.map((item, index) => {
									return (
										<FormLayout.Group condensed>
											{item.type == "name"
												? "Courier name"
												: item.type == "start"
												? "Tracking number start with"
												: "Tracking number end with"}
											{item.courier}
											<Icon source={ArrowRightMinor} />
											{item.paypal_courier}
											<ButtonGroup>
												<Button
													onClick={() =>
														editMapping(item)
													}
												>
													<Icon source={EditMinor} />
												</Button>
												<Button
													onClick={() =>
														deleteMapping(item)
													}
												>
													<Icon
														source={DeleteMinor}
													/>
												</Button>
											</ButtonGroup>
										</FormLayout.Group>
									);
								})}
							</FormLayout>
						</div>
					</Row>
					<Modal
						open={mappingModalStatus}
						onClose={() => setmappingModalStatus(false)}
						title="Courier Mapping"
						primaryAction={{
							content: "Save",
							onAction: () => saveMapping(),
						}}
						secondaryActions={[
							{
								content: "Cancel",
								onAction: () => setmappingModalStatus(false),
							},
						]}
					>
						<Modal.Section>
							<Select
								label="Mapping type"
								options={optionsRule}
								onChange={setmappingRule}
								value={mappingRule}
							/>
							{mappingRule == "name" ? (
								<Autocomplete
									options={options}
									selected={selectedOptions}
									onSelect={updateSelection}
									textField={textField}
								/>
							) : (
								<TextField
									label={
										mappingRule == "start"
											? "Tracking number start with"
											: "Tracking number end with"
									}
									value={yourCourierValue}
									onChange={changeYourCourier}
									helpText={
										mappingRule == "start"
											? "Example: 1ZA"
											: "Example: HK"
									}
									error={yourCourierValueErr}
								/>
							)}
							<Autocomplete
								options={options}
								selected={selectedOptions}
								onSelect={updateSelection2}
								textField={textField2}
							/>
						</Modal.Section>
					</Modal>
					<Modal
						large={true}
						open={modalPlan}
						onClose={() => setModalPlan(false)}
						title="Pricing Table"
						secondaryActions={[
							{
								content: "Cancel",
								onAction: () => setModalPlan(false),
							},
						]}
					>
						<Modal.Section>
							<PlanTable type="step" />
						</Modal.Section>
					</Modal>
				</div>
			</Card>
		</Col>
	);
};

export default CourierMapping;
